import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import ChipInput from 'material-ui-chip-input';
import { getHelpOrError, hasError } from './_common';

const styles = makeStyles(() => ({
  chip: {
    // paddingTop: '8px !important',
    height: '25px',
  },
  container: {
    minHeight: '30px',
  },
}));

const ChipRenderer = ({
  text, isDisabled, isReadOnly, handleClick, handleDelete, className,
}, key) => (
  <Chip
    key={key}
    className={className}
    style={{
      pointerEvents: isDisabled || isReadOnly ? 'none' : undefined,
    }}
    onClick={handleClick}
    onDelete={handleDelete}
    label={text}
    color="primary"
    size="small"
  />
);

ChipRenderer.propTypes = {
  text: PropTypes.string,
  isDisabled: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  handleClick: PropTypes.func,
  handleDelete: PropTypes.func,
  className: PropTypes.string,
};

/**
 * NOTE: This can be later extended to support multiple autocomplete
 * options
 */
const ChipsInput = (props) => {
  const {
    label, name, errors, value, help, onChange, onBlur, onDelete, required, ...rest
  } = props;
  const classes = styles();
  const ref = React.useRef(null);
  const intl = useIntl();

  return (
    <ChipInput
      blurBehavior="add"
      label={label}
      margin="dense"
      defaultValue={value || []}
      value={value || []}
      fullWidth
      fullWidthInput
      helperText={getHelpOrError(help, errors, name)}
      error={hasError(errors, name)}
      onAdd={(v) => {
        onChange(v);

        setTimeout(() => {
          ref?.current?.blur();
          ref?.current.focus();
        }, 50);
      }}
      onDelete={onDelete}
      required={required}
      placeholder={intl.formatMessage({ id: 'chip.help', defaultMessage: '(Press enter to add)' })}
      alwaysShowPlaceholder
      newChipKeyCodes={[9, 13, 188]}
      inputRef={(r) => {
        ref.current = r;
      }}
      InputLabelProps={{
        shrink: true,
      }}
      InputProps={{
        margin: 'dense',
        autoComplete: 'off',
        fullWidth: true,
        onBlur,
        name,
      }}
      chipRenderer={ChipRenderer}
      classes={{
        chipContainer: classes.container,
        inputRoot: classes.chip,
      }}
      {...rest}
    />
  );
};

ChipsInput.propTypes = {
  label: PropTypes.node,
  name: PropTypes.string.isRequired,
  errors: PropTypes.object.isRequired,
  value: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  help: PropTypes.node,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  onDelete: PropTypes.func.isRequired,
  required: PropTypes.bool,
};

export default ChipsInput;
